// Development environment
export const isProd = process.env.NODE_ENV === 'production'

// Browser environment sniffing
export const inBrowser = typeof window !== 'undefined'
export const UA = inBrowser && window.navigator.userAgent.toLowerCase()
export const isAndroid = UA && UA.indexOf('android') > 0
export const isIOS = UA && /iphone|ipad|ipod|ios/.test(UA)



// WEBPACK FOOTER //
// ./src/modules/vxmobile/components/_util/env.js